export const EXHIBIT_PREVIEW_MS = 3_000
export const EXHIBIT_PREVIEW_PUBLISH_INTERVAL_MS = 100
